
<template lang="pug">
  .input.input--checkbox(:class="inputClass")
    input(type="checkbox", :id="'checkbox' + _uid", v-model="currentValue", :disabled="disabled")
    .input--checkbox__indicator
    label(:for="'checkbox' + _uid") {{ label }}
</template>

<script>
  export default {
    name: 'CheckboxInput',
    props: {
      value: Boolean,
      label: String,
      disabled: Boolean,
      checked: Boolean
    },
    data () {
      return {
        currentValue: this.value
      };
    },
    mounted () {
      if (this.checked) {
        this.currentValue = true;
      }
    },
    computed: {
      inputClass () {
        return {
          disabled: this.disabled
        }
      }
    },
    watch: {
      currentlyChecked () {
        this.$emit('input', this.currentValue);
      }
    }
  };
</script>

<style scoped lang="scss">
</style>